import { Accordion, Modal } from 'react-bootstrap';
import { DocsAccordionItem } from 'routes/essential-workspace/components/quote-panel/collapse/docs-item';
import { QuotePanelModalCloseButton } from 'routes/essential-workspace/components/quote-panel/modal/close-button';
import { Quote } from 'routes/essential-workspace/components/quote-panel/quote';
import { useToggle } from 'usehooks-ts';

import './style.scss';

export function QuotePanelModal() {
  const [isToggled, toggle] = useToggle(false);

  return (
    <>
      <Quote isBordered isShadowed isBlurred className="w-100 max-w-480px mx-auto">
        <div onClick={toggle} className="cursor-pointer">
          <Quote.Summary className="p-2" />
        </div>
      </Quote>

      <Modal show={isToggled} fullscreen onHide={toggle}>
        <Quote>
          <Quote.Header className="flex-y gap-3 w-100">
            <div className="flex-x gap-2 w-100">
              <Quote.Modes />
              <Quote.Badge />
              <QuotePanelModalCloseButton onClick={toggle} />
            </div>
            <div className="w-100">
              <Quote.Details />
            </div>
          </Quote.Header>

          <Modal.Body>
            <Accordion className="flex-y gap-3 essential-accordion" flush defaultActiveKey="documents">
              <DocsAccordionItem eventKey="documents" />
            </Accordion>
          </Modal.Body>

          <Modal.Footer>
            <Quote.Actions />
          </Modal.Footer>
        </Quote>
      </Modal>
    </>
  );
}
